export const company = {
  legalName: "MCS Ambiental Desentupidora Ltda",
  tradeName: "Desentupidora Ambiental",
  cnpj: "32.043.657/0001-22",
  municipalRegistration: "251.450-8",
  sfa: "251562",
  founded: "19/11/2018",
  address: "Rua Herminia Rufino Bergonse, 30 – Jardim das Palmeiras, Londrina – PR",
  cep: "86.083-550",
  website: "https://mcsambientaldesentupidora.com.br",
  maps: "https://maps.app.goo.gl/WhkiCuCt9RbFQYRb7",
  instagram: "https://www.instagram.com/desentupidora.mcs24h",
  phoneDisplay: "(43) 98808-5968",
  phoneRaw: "043988085968",
  whatsapp: "5543988085968",
};

export const services = [
  { slug: "hidrojateamento", name: "Hidrojateamento", icon: "Gauge", copy: "Limpeza de alta pressão para esgoto, tubulações, galerias e linhas industriais.", image: "/img/Hidrojateamento.webp" },
  { slug: "limpeza-de-fossa", name: "Limpeza de Fossa", icon: "Truck", copy: "Sucção técnica, descarte responsável e atendimento preventivo para fossas sépticas.", image: "/img/Limpa fossa.webp" },
  { slug: "desentupimento-de-esgoto", name: "Desentupimento de Esgoto", icon: "Waves", copy: "Ação emergencial para retorno de esgoto, mau cheiro e obstruções críticas.", image: "/img/Desentupidora de Esgoto.webp" },
  { slug: "limpeza-de-caixa-de-gordura", name: "Caixa de Gordura", icon: "Droplets", copy: "Remoção de gordura acumulada para restaurantes, condomínios, casas e empresas.", image: "/img/Limpeza de caixa de gordura.webp" },
  { slug: "desentupimento-de-pia", name: "Desentupimento de Pia", icon: "Wrench", copy: "Correção rápida de pia entupida com análise da causa e orientação preventiva.", image: "/img/Desentupidora de Pia.webp" },
  { slug: "caca-vazamentos", name: "Caça Vazamentos", icon: "Search", copy: "Inspeção técnica para identificar vazamentos ocultos sem quebra desnecessária.", image: "/img/Desentupidora de Ralo.webp" },
];

export const allCities = [
  "Londrina",
  "Cambé",
  "Ibiporã",
  "Rolândia",
  "Arapongas",
  "Apucarana",
  "Jataizinho",
  "Bela Vista do Paraíso",
  "Sertanópolis",
  "Tamarana",
  "Norte do Paraná",
];

export const reviews = [
  {
    name: "Condomínio Residencial Jardim Palhano",
    location: "Londrina",
    service: "Desentupimento de esgoto",
    text: "Atendimento excelente. A equipe chegou rápido, explicou o problema e resolveu o retorno de esgoto do condomínio com muita organização.",
  },
  {
    name: "Restaurante Sabor do Norte",
    location: "Cambé",
    service: "Limpeza de caixa de gordura",
    text: "Precisávamos liberar a cozinha com urgência. A Desentupidora Ambiental fez a limpeza técnica sem bagunça e com ótimo suporte.",
  },
  {
    name: "Residência Particular",
    location: "Ibiporã",
    service: "Limpeza de fossa",
    text: "Serviço limpo, bem sinalizado e com orientação para evitar novos problemas. Recomendo pela confiança e pelo preço justo.",
  },
];

export const faqs = [
  {
    q: "Quanto custa uma desentupidora em Londrina?",
    a: "O valor depende do tipo de obstrução, acesso, urgência e equipamento necessário. Em Londrina, a Desentupidora Ambiental avalia o cenário pelo WhatsApp e orienta o orçamento com clareza antes do atendimento.",
  },
  {
    q: "Quando chamar uma desentupidora 24 horas?",
    a: "Chame imediatamente quando houver retorno de esgoto, vaso sanitário transbordando, ralo sem vazão, mau cheiro persistente ou risco de paralisação de casa, comércio, condomínio ou indústria.",
  },
  {
    q: "Como funciona o hidrojateamento?",
    a: "O hidrojateamento usa água em alta pressão para desagregar gordura, areia, raízes e incrustações internas sem agredir a tubulação quando aplicado por equipe treinada e com equipamento correto.",
  },
  {
    q: "Como evitar entupimento de esgoto?",
    a: "Evite jogar óleo, papel em excesso, absorventes, restos de obra e resíduos sólidos na rede. A manutenção preventiva e a limpeza periódica reduzem emergências e custos maiores.",
  },
];